import React from 'react';
import Modal from '../Modal';
import PropTypes from 'prop-types';

const ConfirmationModal = ({
  isOpen,
  onClose,
  contentWidth,
  onSave,
  buttonPosition,
  content,
  cancelButton,
  confirmButton,
  showIcon,
  icon,
  successNotification,
  titleName,
  hideHeader
}) => {
  const handleConfirmation = () => {
    onSave();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentWidth={contentWidth}
      detailHeight={'auto'}
      hideHeader={hideHeader}
      titleName={titleName}>
      <div className="confirmation-wrapper">
        <div className="confirmation-content">
          <div className={`${showIcon ? 'confirmation-icon pb-3' : 'd-none'}`}>
            <img src={icon} className="img-fluid" />
          </div>
          {successNotification && 
            <div><span className='fw-bold d-flex justify-content-center success-text'>Success</span></div>
          }
          <div>
            <p className="mb-0" dangerouslySetInnerHTML={{ __html: content}}></p>
          </div>
        </div>
        <div className={`d-flex justify-content-${buttonPosition} gap-2 pt-3`}>
          <button
            className={`btn btn-castleWhite ${successNotification?'d-none':''}`}
            style={{width:'100px'}}
            onClick={handleConfirmation}>
            {confirmButton}
          </button>
          <button className="btn btn-castleRed"
            style={{width:'100px'}}
            onClick={onClose}>
            {cancelButton}
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentWidth: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  buttonPosition: PropTypes.string,
  content: PropTypes.string,
  cancelButton: PropTypes.string,
  confirmButton: PropTypes.string,
  showIcon: PropTypes.bool,
  icon: PropTypes.string,
  successNotification: PropTypes.bool,
  titleName: PropTypes.string,
  hideHeader: PropTypes.bool
};

export default ConfirmationModal;
